import { defer, switchMap } from 'rxjs';

// import { RxCollection } from 'rxdb';
// import type { FeatureFlagView2 } from '@mopla/data-models';
// import { DEFAULT_FEATURE_FLAGS } from '../constants/featureFlagConstants';
// import { FEATURE_FLAGS_DOC_ID } from '../entities/featureFlag';
// import { FeatureFlagDocument } from '../schemas/featureFlagSchema';
import {
	EFeatureFlagActionTypes,
	fetchFeatureFlagsResult,
	// IFeatureFlagsResponse,
	TFetchFeatureFlagsAction,
} from '../actions/featureFlagActions';
import { Effect } from '../business-logic';
import { ofType } from '../operators/ofType';

/**
 * Integration point for API-driven feature flags.
 *
 * No backend flag is fetched right now: `isNewHomePageAvailable` — the only flag
 * this effect used to GET — was removed once the backend hardcoded it to `true`.
 * Remaining flags resolve from env/defaults in the FeatureFlagProvider.
 *
 * To add an API flag: restore the commented block below (GET + persist to the
 * `featureflags` RxDB collection) and dispatch it via `fetchFeatureFlagsResult`.
 */
export const fetchFeatureFlagsEffect: Effect<TFetchFeatureFlagsAction> = (
	actions$
) =>
	actions$.pipe(
		ofType(EFeatureFlagActionTypes.FetchFeatureFlags),
		switchMap(() =>
			defer(async () => fetchFeatureFlagsResult({ featureFlags: {} }))
		)
		/* --- Restore to fetch an API flag ---
		switchMap(() =>
			defer(async () => {
				try {
					const response = await dependencies.api.get<FeatureFlagView2>(
						'/api/v2/feature-flags/<flagName>'
					);

					const featureFlags: IFeatureFlagsResponse = {
						<flagName>: Boolean(response.value),
					};

					const collection = dependencies.db[
						'featureflags'
					] as RxCollection<FeatureFlagDocument>;

					const doc = await collection.findOne(FEATURE_FLAGS_DOC_ID).exec();

					if (!doc) {
						await collection.insert({
							id: FEATURE_FLAGS_DOC_ID,
							flags: featureFlags as unknown as Record<string, boolean>,
							lastUpdated: new Date().toISOString(),
							version: 1,
						});
					} else {
						await doc.update({
							$set: {
								flags: { ...doc.flags, ...featureFlags },
								lastUpdated: new Date().toISOString(),
								version: doc.version + 1,
							},
						});
					}

					return fetchFeatureFlagsResult({ featureFlags });
				} catch (error: any) {
					dependencies.Sentry.captureException(error);

					const collection = dependencies.db[
						'featureflags'
					] as RxCollection<FeatureFlagDocument>;
					const doc = await collection.findOne(FEATURE_FLAGS_DOC_ID).exec();

					if (!doc) {
						await collection.insert({
							id: FEATURE_FLAGS_DOC_ID,
							flags: DEFAULT_FEATURE_FLAGS as unknown as Record<string, boolean>,
							lastUpdated: new Date().toISOString(),
							version: 1,
						});
					}

					return fetchFeatureFlagsResult({
						featureFlags: DEFAULT_FEATURE_FLAGS,
						error,
					});
				}
			})
		)
		--- */
	);
